import React from 'react';
import { ArticleLayout } from '../../components/ArticleLayout';

export const XliffToExcelArticle: React.FC = () => {
    return (
        <ArticleLayout
            title="Converting XLIFF Back to Excel: The Return Trip"
            subtitle="Seamlessly merge translated content back into your original Excel structure."
        >
            <h3>The Import Problem</h3>
            <p>
                After your translators have finished their work in Trados or MemoQ, you're left with a translated XLIFF file.
                The challenge is getting that text back into your specific Excel layout without manual copy-pasting.
                Manual entry is slow, expensive, and prone to human error.
            </p>

            <h3>Automated Merging</h3>
            <p>
                The "Merge" function in our converter automates this process. It takes your original Excel file (as a template)
                and the translated XLIFF files, then reconstructs the Excel workbook with the translations in the correct columns.
            </p>

            <h3>Key Benefits</h3>
            <ul>
                <li><strong>Structure Preservation:</strong> Your formatting, formulas, and sheet layout remain untouched.</li>
                <li><strong>Multi-Language Support:</strong> Merge multiple XLIFF files (e.g., French, German, Spanish) into a single multilingual Excel sheet in one go.</li>
                <li><strong>Error Reduction:</strong> Eliminate copy-paste errors and row mismatches.</li>
            </ul>

            <h3>Best Practices</h3>
            <p>
                Always keep your original Excel file safe. It serves as the "skeleton" for the merge process.
                Ensure that the unique identifiers (keys) in your XLIFF haven't been altered during translation.
            </p>
        </ArticleLayout>
    );
};
